var map = {
	"./AddAddressIcon.tsx": 8885,
	"./AddIcon.tsx": 823,
	"./AddressIcon.tsx": 2674,
	"./ArrowClickIcon.tsx": 7919,
	"./ArrowDownIcon.tsx": 7713,
	"./BackIcon.tsx": 6879,
	"./ChooseIcon.tsx": 2441,
	"./ChoosedIcon.tsx": 8747,
	"./DeliveryIcon.tsx": 9746,
	"./DineInIcon.tsx": 6453,
	"./DineInSmallIcon.tsx": 8486,
	"./EditAddressIcon.tsx": 950,
	"./Enicon.tsx": 5375,
	"./HeaderIcon.tsx": 4849,
	"./MinusIcon.tsx": 990,
	"./NoAddressIcon.tsx": 5837,
	"./PickUpIcon.tsx": 6278,
	"./PostionIcon.tsx": 2154,
	"./ScanCodeFailedIcon.tsx": 4741,
	"./ShoppingCartIcon.tsx": 1004,
	"./SuccessIcon.tsx": 5867,
	"./TakeawayIcon.tsx": 7221,
	"./TipIcon.tsx": 7417,
	"./TrashIcon.tsx": 8104,
	"./ZhCnIcon.tsx": 699,
	"./ZhHkIcon.tsx": 7191,
	"components/svg/AddAddressIcon.tsx": 8885,
	"components/svg/AddIcon.tsx": 823,
	"components/svg/AddressIcon.tsx": 2674,
	"components/svg/ArrowClickIcon.tsx": 7919,
	"components/svg/ArrowDownIcon.tsx": 7713,
	"components/svg/BackIcon.tsx": 6879,
	"components/svg/ChooseIcon.tsx": 2441,
	"components/svg/ChoosedIcon.tsx": 8747,
	"components/svg/DeliveryIcon.tsx": 9746,
	"components/svg/DineInIcon.tsx": 6453,
	"components/svg/DineInSmallIcon.tsx": 8486,
	"components/svg/EditAddressIcon.tsx": 950,
	"components/svg/Enicon.tsx": 5375,
	"components/svg/HeaderIcon.tsx": 4849,
	"components/svg/MinusIcon.tsx": 990,
	"components/svg/NoAddressIcon.tsx": 5837,
	"components/svg/PickUpIcon.tsx": 6278,
	"components/svg/PostionIcon.tsx": 2154,
	"components/svg/ScanCodeFailedIcon.tsx": 4741,
	"components/svg/ShoppingCartIcon.tsx": 1004,
	"components/svg/SuccessIcon.tsx": 5867,
	"components/svg/TakeawayIcon.tsx": 7221,
	"components/svg/TipIcon.tsx": 7417,
	"components/svg/TrashIcon.tsx": 8104,
	"components/svg/ZhCnIcon.tsx": 699,
	"components/svg/ZhHkIcon.tsx": 7191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4670;